export default __webpack_public_path__ + "static/media/plus.18368c9f.svg";